var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 37,
    viewBox: "0 0 222 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6951 13.1168C31.6951 20.3622 26.664 26.2357 20.4576 26.2357C14.2513 26.2357 9.22021 20.3622 9.22021 13.1168C9.22021 5.95005 14.1428 0.125557 20.256 0H20.6593C26.7726 0.125557 31.6951 5.95005 31.6951 13.1168Z",
    fill: "#FFD25D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7347 0.0135193V23.545H6.72328L0 32.6605V0.0135193H13.7347Z",
    fill: "#0082BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4753 23.5447L31.6958 37H15.9441L6.72363 23.5447H22.4753Z",
    fill: "#00D4A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1318 26.262V10.8369H49.976V13.3374C50.3371 12.6081 50.9355 11.9673 51.7712 11.4151C52.607 10.8525 53.5665 10.5712 54.6498 10.5712C55.2173 10.5712 55.7022 10.6597 56.1046 10.8369V15.2909C55.7642 15.2076 55.4753 15.1503 55.238 15.119C55.011 15.0773 54.7272 15.0565 54.3867 15.0565C53.0558 15.0565 51.9879 15.4524 51.1831 16.2443C50.3784 17.0361 49.976 18.3697 49.976 20.2451V26.262H45.1318Z",
    fill: "url(#paint0_linear_37_94)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3353 5.71075C57.3353 4.83556 57.6294 4.10103 58.2175 3.50715C58.8159 2.91327 59.5588 2.61633 60.4461 2.61633C60.8897 2.61633 61.3025 2.69447 61.6842 2.85076C62.066 3.00704 62.3961 3.22584 62.6747 3.50715C62.9636 3.77804 63.1854 4.10624 63.3402 4.49174C63.5053 4.87724 63.5878 5.28357 63.5878 5.71075C63.5878 6.13792 63.5053 6.53905 63.3402 6.91413C63.1854 7.28921 62.9636 7.62262 62.6747 7.91435C62.3961 8.19566 62.066 8.41966 61.6842 8.58637C61.3025 8.74265 60.8897 8.82079 60.4461 8.82079C60.0024 8.82079 59.5949 8.74265 59.2234 8.58637C58.852 8.41966 58.5218 8.19566 58.233 7.91435C57.9544 7.62262 57.7326 7.28921 57.5675 6.91413C57.4127 6.53905 57.3353 6.13792 57.3353 5.71075ZM58.0318 26.262V10.8369H62.8759V26.262H58.0318Z",
    fill: "url(#paint1_linear_37_94)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6852 18.5416C65.6852 17.4789 65.8554 16.4579 66.1959 15.4785C66.5467 14.4991 67.0677 13.6343 67.759 12.8842C68.4606 12.134 69.3221 11.5349 70.3436 11.0869C71.3753 10.6389 72.5567 10.4149 73.8877 10.4149C75.1774 10.4149 76.2969 10.5972 77.2461 10.9619C78.1953 11.3265 78.9898 11.811 79.6294 12.4153C80.2795 13.0092 80.7799 13.6968 81.1307 14.4783C81.4815 15.2493 81.6981 16.0515 81.7807 16.885H76.9365C76.8334 16.1974 76.5496 15.64 76.0853 15.2128C75.6314 14.7856 74.9091 14.572 73.9186 14.572C73.3512 14.572 72.8508 14.6814 72.4174 14.9002C71.9841 15.1086 71.6281 15.3951 71.3496 15.7598C71.0813 16.1244 70.8749 16.5464 70.7305 17.0257C70.5964 17.505 70.5293 18.0103 70.5293 18.5416C70.5293 19.073 70.5964 19.5835 70.7305 20.0732C70.8749 20.5525 71.0865 20.9744 71.365 21.3391C71.6539 21.6934 72.0254 21.9799 72.4793 22.1987C72.9333 22.407 73.475 22.5112 74.1044 22.5112C74.9504 22.5112 75.5849 22.3393 76.008 21.9955C76.431 21.6413 76.7508 21.1307 76.9675 20.4639H81.8116C81.6878 21.3391 81.435 22.157 81.0533 22.9176C80.6715 23.6782 80.1505 24.3345 79.4902 24.8867C78.8401 25.4389 78.0457 25.8765 77.1068 26.1995C76.1679 26.5225 75.0949 26.684 73.8877 26.684C72.5567 26.684 71.3753 26.46 70.3436 26.012C69.3221 25.564 68.4606 24.9649 67.759 24.2147C67.0677 23.4646 66.5467 22.5998 66.1959 21.6204C65.8554 20.641 65.6852 19.6148 65.6852 18.5416Z",
    fill: "url(#paint2_linear_37_94)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6054 26.262V3.85097H89.2948V13.0717C89.7178 12.259 90.3524 11.6183 91.1984 11.1494C92.0444 10.6806 93.0607 10.4461 94.2473 10.4461C95.2378 10.4461 96.0683 10.6024 96.739 10.915C97.4199 11.2276 97.9719 11.6599 98.3949 12.2121C98.8799 12.806 99.2049 13.4989 99.37 14.2907C99.5454 15.0826 99.6331 16.0307 99.6331 17.1351V26.262H94.9437V18.3541C94.9437 17.2497 94.7477 16.3537 94.3556 15.666C93.9635 14.9679 93.2619 14.6189 92.2508 14.6189C91.2603 14.6189 90.5174 14.9732 90.0222 15.6816C89.5373 16.3797 89.2948 17.3226 89.2948 18.5104V26.262H84.6054Z",
    fill: "url(#paint3_linear_37_94)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.201 26.262V10.8369H108.045V13.3374C108.406 12.6081 109.004 11.9673 109.84 11.4151C110.676 10.8525 111.635 10.5712 112.719 10.5712C113.286 10.5712 113.771 10.6597 114.173 10.8369V15.2909C113.833 15.2076 113.544 15.1503 113.307 15.119C113.08 15.0773 112.796 15.0565 112.456 15.0565C111.125 15.0565 110.057 15.4524 109.252 16.2443C108.447 17.0361 108.045 18.3697 108.045 20.2451V26.262H103.201Z",
    fill: "url(#paint4_linear_37_94)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.491 26.262V10.8369H128.18V13.0717C128.521 12.3424 129.068 11.7225 129.821 11.2119C130.584 10.7014 131.508 10.4461 132.591 10.4461C133.922 10.4461 134.943 10.717 135.655 11.2588C136.378 11.7902 136.899 12.4466 137.219 13.228C137.621 12.4153 138.235 11.7485 139.06 11.2276C139.886 10.7066 140.866 10.4461 142.001 10.4461C143.094 10.4461 143.992 10.6233 144.694 10.9775C145.395 11.3317 145.947 11.8058 146.35 12.3997C146.752 12.9831 147.02 13.6552 147.154 14.4157C147.289 15.1659 147.356 15.9473 147.356 16.76V26.262H142.697V17.9478C142.697 16.9059 142.511 16.0932 142.14 15.5097C141.779 14.9159 141.186 14.6189 140.36 14.6189C139.999 14.6189 139.659 14.6814 139.339 14.8065C139.019 14.9315 138.74 15.1451 138.503 15.4472C138.276 15.7389 138.101 16.1401 137.977 16.6506C137.853 17.1507 137.791 17.7706 137.791 18.5104V26.262H133.102V17.9009C133.102 16.859 132.921 16.0515 132.56 15.4785C132.199 14.9054 131.616 14.6189 130.811 14.6189C130.43 14.6189 130.079 14.6814 129.759 14.8065C129.449 14.9315 129.176 15.1503 128.939 15.4628C128.712 15.765 128.526 16.1765 128.381 16.6975C128.247 17.208 128.18 17.8488 128.18 18.6198V26.262H123.491Z",
    fill: "url(#paint5_linear_37_94)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.964 18.5416C149.964 17.4372 150.155 16.3953 150.536 15.416C150.928 14.4366 151.491 13.577 152.223 12.8373C152.956 12.0975 153.843 11.5089 154.885 11.0713C155.927 10.6337 157.104 10.4149 158.414 10.4149C159.745 10.4149 160.931 10.6337 161.973 11.0713C163.026 11.5089 163.913 12.0975 164.635 12.8373C165.368 13.577 165.93 14.4366 166.322 15.416C166.714 16.3953 166.91 17.4372 166.91 18.5416C166.91 19.646 166.714 20.6931 166.322 21.6829C165.93 22.6623 165.368 23.5219 164.635 24.2616C163.913 25.0014 163.026 25.59 161.973 26.0276C160.931 26.4652 159.745 26.684 158.414 26.684C157.104 26.684 155.927 26.4652 154.885 26.0276C153.843 25.59 152.956 25.0014 152.223 24.2616C151.491 23.5219 150.928 22.6623 150.536 21.6829C150.155 20.7036 149.964 19.6565 149.964 18.5416ZM154.808 18.5416C154.808 19.0938 154.89 19.6096 155.055 20.0888C155.231 20.5577 155.473 20.9744 155.783 21.3391C156.103 21.6934 156.484 21.9747 156.928 22.183C157.372 22.381 157.867 22.48 158.414 22.48C158.961 22.48 159.461 22.381 159.915 22.183C160.379 21.9747 160.766 21.6934 161.076 21.3391C161.396 20.9744 161.643 20.5577 161.819 20.0888C162.004 19.62 162.097 19.1043 162.097 18.5416C162.097 18.0103 162.004 17.505 161.819 17.0257C161.643 16.5464 161.396 16.1297 161.076 15.7754C160.766 15.4212 160.385 15.1399 159.931 14.9315C159.477 14.7231 158.971 14.6189 158.414 14.6189C157.867 14.6189 157.372 14.7231 156.928 14.9315C156.484 15.1399 156.103 15.4212 155.783 15.7754C155.473 16.1297 155.231 16.5464 155.055 17.0257C154.89 17.505 154.808 18.0103 154.808 18.5416Z",
    fill: "url(#paint6_linear_37_94)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.658 26.262V10.8369H174.502V13.0717C174.925 12.2382 175.565 11.5922 176.421 11.1338C177.277 10.6754 178.309 10.4461 179.516 10.4461C180.507 10.4461 181.363 10.6024 182.085 10.915C182.808 11.2276 183.38 11.6599 183.803 12.2121C184.288 12.806 184.608 13.4937 184.763 14.2751C184.918 15.0565 184.995 15.9994 184.995 17.1038V26.262H180.151V18.3541C180.151 17.2497 179.955 16.3537 179.563 15.666C179.171 14.9679 178.469 14.6189 177.458 14.6189C176.467 14.6189 175.725 14.9732 175.229 15.6816C174.744 16.3797 174.502 17.3226 174.502 18.5104V26.262H169.658Z",
    fill: "url(#paint7_linear_37_94)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.618 18.5416C187.618 17.406 187.789 16.3485 188.129 15.3691C188.48 14.3897 188.996 13.5353 189.677 12.806C190.368 12.0663 191.214 11.4828 192.215 11.0556C193.226 10.6285 194.397 10.4149 195.728 10.4149C196.935 10.4149 198.019 10.6076 198.978 10.9931C199.938 11.3786 200.758 11.8944 201.439 12.5403C202.13 13.1759 202.662 13.9208 203.033 14.7752C203.404 15.6295 203.59 16.5256 203.59 17.4633C203.59 17.7863 203.585 18.1301 203.575 18.4947C203.564 18.849 203.518 19.2605 203.435 19.7294H192.432C192.452 20.1982 192.519 20.641 192.633 21.0578C192.757 21.4746 192.948 21.8392 193.206 22.1518C193.474 22.4644 193.819 22.7092 194.242 22.8863C194.665 23.0634 195.192 23.152 195.821 23.152C196.667 23.152 197.307 22.9853 197.74 22.6519C198.173 22.3081 198.473 21.8913 198.638 21.4016H203.404C203.301 22.1309 203.054 22.8134 202.662 23.4489C202.27 24.0845 201.749 24.6419 201.098 25.1212C200.459 25.6004 199.7 25.9807 198.823 26.262C197.946 26.5434 196.956 26.684 195.852 26.684C194.521 26.684 193.34 26.486 192.308 26.0901C191.286 25.6942 190.425 25.1368 189.723 24.4179C189.032 23.6886 188.506 22.829 188.145 21.8392C187.794 20.839 187.618 19.7398 187.618 18.5416ZM192.432 16.9163H198.839C198.839 15.9161 198.545 15.1294 197.957 14.5564C197.379 13.9729 196.626 13.6812 195.697 13.6812C194.748 13.6812 193.964 13.9625 193.345 14.5251C192.736 15.0773 192.432 15.8744 192.432 16.9163Z",
    fill: "url(#paint8_linear_37_94)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206.384 27.4498H211.228C211.269 28.325 211.569 28.9918 212.126 29.4502C212.693 29.9087 213.379 30.1379 214.184 30.1379C215.113 30.1379 215.84 29.9087 216.366 29.4502C216.893 28.9918 217.156 28.1635 217.156 26.9653V23.7928C216.733 24.6263 216.103 25.267 215.267 25.715C214.432 26.1631 213.436 26.3871 212.281 26.3871C211.269 26.3871 210.387 26.2204 209.634 25.887C208.881 25.5431 208.293 25.0899 207.87 24.5273C207.385 23.9334 207.065 23.2718 206.91 22.5425C206.766 21.8028 206.694 20.8755 206.694 19.7606V10.8369H211.522V18.7448C211.522 19.8492 211.713 20.7504 212.095 21.4485C212.487 22.1362 213.194 22.48 214.215 22.48C215.226 22.48 215.969 22.1309 216.444 21.4329C216.918 20.7244 217.156 19.7711 217.156 18.5729V10.8369H222V26.6528C222 27.8718 221.809 28.9241 221.427 29.8097C221.056 30.7057 220.54 31.435 219.879 31.9977C219.199 32.5707 218.399 32.9874 217.481 33.2479C216.573 33.5188 215.453 33.6543 214.122 33.6543C212.874 33.6543 211.79 33.524 210.872 33.2635C209.954 33.0135 209.154 32.6124 208.473 32.0602C207.865 31.5496 207.364 30.9141 206.972 30.1535C206.58 29.3929 206.384 28.4917 206.384 27.4498Z",
    fill: "url(#paint9_linear_37_94)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_94",
    x1: 45.1052,
    y1: 18.8758,
    x2: 224.308,
    y2: 19.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FFD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#CBD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#00D4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37_94",
    x1: 45.1052,
    y1: 18.8758,
    x2: 224.308,
    y2: 19.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FFD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#CBD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#00D4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_37_94",
    x1: 45.1052,
    y1: 18.8758,
    x2: 224.308,
    y2: 19.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FFD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#CBD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#00D4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_37_94",
    x1: 45.1052,
    y1: 18.8758,
    x2: 224.308,
    y2: 19.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FFD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#CBD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#00D4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_37_94",
    x1: 45.1052,
    y1: 18.8758,
    x2: 224.308,
    y2: 19.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FFD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#CBD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#00D4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_37_94",
    x1: 45.1052,
    y1: 18.8758,
    x2: 224.308,
    y2: 19.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FFD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#CBD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#00D4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_37_94",
    x1: 45.1052,
    y1: 18.8758,
    x2: 224.308,
    y2: 19.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FFD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#CBD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#00D4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_37_94",
    x1: 45.1052,
    y1: 18.8758,
    x2: 224.308,
    y2: 19.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FFD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#CBD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#00D4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_37_94",
    x1: 45.1052,
    y1: 18.8758,
    x2: 224.308,
    y2: 19.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FFD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#CBD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#00D4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_37_94",
    x1: 45.1052,
    y1: 18.8758,
    x2: 224.308,
    y2: 19.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FFD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#CBD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#00D4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082BC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.cafc898bb0b704b59d5ae14e44fdbea5.svg";
export { ForwardRef as ReactComponent };